// Supermove
import {gql} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {CallrailIntegrationModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

export interface UpdateCallrailIntegrationFormType {
  // Required fields
  callrailIntegrationId: string;
  projectTypeId: string;
  jobTypeId: string;
  callrailExcludedPhoneNumbers: string[];
}

const _new = ({
  callrailIntegration,
}: {
  callrailIntegration: CallrailIntegrationModel;
}): UpdateCallrailIntegrationFormType => {
  return {
    callrailIntegrationId: callrailIntegration.id,
    projectTypeId: callrailIntegration.projectTypeId || '',
    jobTypeId: callrailIntegration.jobTypeId || '',
    callrailExcludedPhoneNumbers: callrailIntegration.callrailExcludedPhoneNumbers
      ? callrailIntegration.callrailExcludedPhoneNumbers.map((x) => x.number)
      : [],
  };
};

const edit = withFragment<CallrailIntegrationModel, UpdateCallrailIntegrationFormType>(
  (callrailIntegration) => ({
    callrailIntegrationId: callrailIntegration.id,
    projectTypeId: callrailIntegration.projectTypeId || '',
    jobTypeId: callrailIntegration.jobTypeId || '',
    callrailExcludedPhoneNumbers: callrailIntegration.callrailExcludedPhoneNumbers
      ? callrailIntegration.callrailExcludedPhoneNumbers.map((x) => x.number)
      : [],
  }),
  gql`
    fragment UpdateCallrailIntegrationForm_edit on CallrailIntegration {
      id
      projectTypeId
      jobTypeId
      callrailExcludedPhoneNumbers {
        id
        number
      }
    }
  `,
);

export interface UpdateCallrailIntegrationFormToFormType {
  callrailIntegrationId: string;
  projectTypeId: string;
  jobTypeId: string;
  callrailExcludedPhoneNumbers: string[];
}

export type FormikUpdateCallrailIntegrationFormType = Form<{
  updateCallrailIntegrationForm: UpdateCallrailIntegrationFormToFormType;
}>;

const toForm = (
  updateCallrailIntegrationForm: UpdateCallrailIntegrationFormType,
): UpdateCallrailIntegrationFormToFormType => ({
  callrailIntegrationId: updateCallrailIntegrationForm.callrailIntegrationId,
  projectTypeId: updateCallrailIntegrationForm.projectTypeId,
  jobTypeId: updateCallrailIntegrationForm.jobTypeId,
  callrailExcludedPhoneNumbers: updateCallrailIntegrationForm.callrailExcludedPhoneNumbers,
});

const toMutation = (updateCallrailIntegrationForm: UpdateCallrailIntegrationFormToFormType) => ({
  callrailIntegrationId: updateCallrailIntegrationForm.callrailIntegrationId,
  projectTypeId: updateCallrailIntegrationForm.projectTypeId,
  jobTypeId: updateCallrailIntegrationForm.jobTypeId,
  callrailExcludedPhoneNumbers: updateCallrailIntegrationForm.callrailExcludedPhoneNumbers,
});

const UpdateCallrailIntegrationForm = {
  toForm,
  toMutation,
  new: _new,
  edit,
};

export default UpdateCallrailIntegrationForm;
